import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Helper } from '../../../../shared/helper';
import { OmniValidators } from '../../../../shared/validators';
import { Util } from '../../../../utils/util';

@Component({
	selector: 'app-pix-receive-payment-professional',
	templateUrl: './professional.component.html',
	styleUrls: ['./professional.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceivePaymentProfessionalComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public minDate = new Date(new Date());
	get toggleJurosMulta() { return this.form.get('toggleJurosMulta').value; }
	get toggleDesconto() { return this.form.get('toggleDesconto').value; }
	get toggleIdentPagador() { return this.form.get('toggleIdentPagador').value; }
	get toggleDataExp() { return this.form.get('toggleDataExp').value; }

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog
	) { }

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			chave: 'gabriel@db1.com.br',
			valor: ['', [Validators.required, Validators.min(1), Validators.max(999999999)]],
			identificador: ['', Validators.pattern(Util.allowedCharactersRegex)],
			descricao: ['', Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)],
			vencimento: [''],
			jurosPorAtraso: [''],
			multaPorAtraso: [''],
			valorDesconto: [''],
			diasAntesVencer: [''],
			nome: [''],
			cpfCnpj: [''],
			dataExpiracao: [''],
			toggleJurosMulta: [false],
			toggleDesconto: [false],
			toggleIdentPagador: [false],
			toggleDataExp: [false],
		});
	}

	goBack() {
		this.router.navigate(['pix/receber']);
	}

	submit() {
		if (this.form.valid) {
			this.router.navigate(['pix/receber/resumo']);
		}
	}

	cpfcnpjMask(event) {
		if (!event.target.value) {
			return;
		}

		let newVal = event.target.value.replace(/\D/g, '');

		if (event.keyCode === 8) {
			return;
		}

		newVal = Helper.maskCpfCnpj(newVal);

		if (newVal.length <= 13) {
			this.form.controls.cpfCnpj.setValidators([OmniValidators.isValidCpfCnpj]);
			this.form.controls.cpfCnpj.updateValueAndValidity();
		} else if (newVal.length > 13) {
			this.form.controls.cpfCnpj.setValidators([OmniValidators.isValidCpfCnpj]);
			this.form.controls.cpfCnpj.updateValueAndValidity();
		}

		this.form.controls.cpfCnpj.setValue(newVal);

	}

	changeValorDesconto() {
		if (this.form.controls.valorDesconto) {
			this.form.controls.cpfCnpj.setValidators([Validators.required]);
			this.form.controls.cpfCnpj.updateValueAndValidity();
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/receive-payment/professional/professional.component.ts